import { Rating } from '@mui/material';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';

interface HealthRatingProps {
  value: number | null;
  readOnly?: boolean;
  onChange?: (newValue: number | null) => void;
  size?: 'small' | 'medium' | 'large';
}

const HealthRating = ({ value, readOnly = true, onChange, size = 'medium' }: HealthRatingProps) => {
  const displayValue = value !== null ? value / 2 : null;

  const handleChange = (_event: React.SyntheticEvent, newDisplayValue: number | null) => {
    if (onChange) {
      const newHealthiness = newDisplayValue !== null ? newDisplayValue * 2 : null;
      onChange(newHealthiness);
    }
  };

  return (
    <Rating
      value={displayValue}
      readOnly={readOnly}
      onChange={readOnly ? undefined : handleChange}
      precision={0.5}
      size={size}
      icon={<FavoriteRoundedIcon fontSize="inherit" color="success" />}
      emptyIcon={<FavoriteBorderRoundedIcon fontSize="inherit" />}
    />
  );
};

export default HealthRating;
